<template>
  <div>
    <UserV></UserV>
  </div>
</template>

<script>
import UserV from '../components/UserVerify.vue';

export default {
  components: {
    UserV,
  },
};
</script>